module.exports = __webpack_public_path__ + "static/aboutus_sample_2.ca120ac8.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/aboutus/aboutus_sample_2.png
// module id = 1087
// module chunks = 4035221647099